'use client';
import { useEffect, useState } from 'react';
import PreShip from './pre-ship';
import { db } from '@/lib/db';
import { useDispatch } from 'react-redux';
import { setPreShipData } from '@/redux/slices/pre-ship/preShipSlice';
import { showSuccessToast, showErrorToast } from "@/components/toast/toast";

interface OfflinePreShipProps {
  projectId: string;
  isOffline?: boolean;
}

export default function OfflinePreShip({ projectId, isOffline }: OfflinePreShipProps) {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const loadPreShipData = async () => {
      if (projectId) {
        try {
          setIsLoading(true);
          const project = await db.getFullProject(projectId);

          if (project?.preShipData) {
            dispatch(setPreShipData(project.preShipData));
          }
        } catch (error) {
          console.error('Error loading pre-ship data:', error);
          showErrorToast('Failed to load pre-ship configuration');
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    loadPreShipData();
  }, [projectId, dispatch]);

  const handleOfflineSubmit = async (values: any) => {
    try {
      const project = await db.getFullProject(projectId);
      if (project) {
        await db.projects.update(projectId, {
          ...project,
          preShipData: {
            ...values,
            updatedAt: new Date().toISOString()
          }
        });
        showSuccessToast("Pre-ship data saved offline");
      }
    } catch (error) {
      console.error('Error saving pre-ship data:', error);
      showErrorToast("Failed to save pre-ship data");
    }
  };

  if (isLoading) {
    return <div>Loading pre-ship configuration...</div>;
  }

  return (
    <PreShip
      projectId={projectId}
      isOffline={isOffline}
      onOfflineSubmit={handleOfflineSubmit}
    />
  );
}
